import React, { useEffect } from 'react';
import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { EarlyMoveInDate } from './EarlyMoveInDate';
import { LateMoveOutDate } from './LateMoveOutDate';
import { EmiNumberOfDays } from './EmiNumberOfDays';
import { LmoNumberOfDays } from './LmoNumberOfDays';
import { EmiDaysWaived } from './EmiDaysWaived';
import { LmoDaysWaived } from './LmoDaysWaived';
import { EmiCostPerDay } from './EmiCostPerDay';
import { LmoCostPerDay } from './LmoCostPerDay';
import { CurrentDates } from './CurrentDates';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectPlacementHeaderData } from 'store/redux-store/placement-details/selectors';
import { selectIsEmiLmoUndo } from 'store/redux-store/placement-mods/selectors';

const useStyles = makeStyles()(theme => ({
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    minWidth: '500px',
    maxWidth: '500px',
    paddingBottom: '24px',
  },
  root: {
    flexGrow: 1,
  },
  divider: {
    marginBottom: '20px',
  },
  dataContent: {
    '& .MuiFormHelperText-root': {
      width: 'max-content !important',
    },
  },
}));

export const EmiLmo = () => {
  const { classes } = useStyles();
  const { setValue, register } = useFormContext();
  const placementDetails = useSelector(selectPlacementHeaderData);
  const isEmiLmoUndo = useSelector(selectIsEmiLmoUndo);
  register('placementStartDate');
  register('placementEndDate');

  useEffect(() => {
    if ((placementDetails && Object.keys(placementDetails).length > 0) || isEmiLmoUndo) {
      setValue('placementStartDate', placementDetails?.placementStartDate);
      setValue('placementEndDate', placementDetails?.placementEndDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placementDetails, isEmiLmoUndo]);

  return (
    <>
      <div className={classes.root}>
        <CurrentDates />
        <Grid className={classes.divider}>
          <Grid xs={12} item>
            <Divider />
          </Grid>
        </Grid>
        <Grid container spacing={4} className={classes.gridContainer}>
          <Grid xs={6} item className={classes.dataContent}>
            <EarlyMoveInDate />
          </Grid>
          <Grid xs={6} item className={classes.dataContent}>
            <LateMoveOutDate />
          </Grid>

          <Grid xs={6} item>
            <EmiNumberOfDays />
          </Grid>
          <Grid xs={6} item>
            <LmoNumberOfDays />
          </Grid>
          <Grid xs={6} item>
            <EmiDaysWaived />
          </Grid>
          <Grid xs={6} item>
            <LmoDaysWaived />
          </Grid>

          <Grid xs={6} item>
            <EmiCostPerDay />
          </Grid>
          <Grid xs={6} item>
            <LmoCostPerDay />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
